import { useEffect, useState } from "react";

const SECTIONS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "pranic", label: "Pranic Healing" },
  { id: "services", label: "Services" },
  { id: "blogs", label: "Blogs" },
  { id: "testimonials", label: "Testimonials" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <nav
      className={`nav ${scrolled ? "nav--solid" : "nav--initial"}`}
      data-testid="main-nav"
    >
      <div className="container nav__inner">
        <a href="#home" onClick={go("home")} className="nav__brand" data-testid="nav-brand">
          <span className="nav__brand-mark">✿</span>
          <span>
            <span className="nav__brand-name">Neuro-Prana</span>
            <span className="nav__brand-sub">Wellness Centre</span>
          </span>
        </a>

        <ul className="nav__links">
          {SECTIONS.map((s) => (
            <li key={s.id}>
              <button
                className="nav__link"
                onClick={go(s.id)}
                data-testid={`nav-link-${s.id}`}
              >
                {s.label}
              </button>
            </li>
          ))}
        </ul>

        <a
          href="#contact"
          onClick={go("contact")}
          className="btn nav__cta"
          data-testid="nav-cta-book"
        >
          Book an Appointment
        </a>

        <button
          className="nav__toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-toggle"
        >
          <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"}`}></i>
        </button>
      </div>

      {open && (
        <div className="nav__mobile">
          <div className="nav__mobile-inner">
            {SECTIONS.map((s) => (
              <button
                key={s.id}
                className="nav__link"
                onClick={go(s.id)}
                data-testid={`nav-mobile-${s.id}`}
              >
                {s.label}
              </button>
            ))}
            <a
              href="#contact"
              onClick={go("contact")}
              className="btn"
              data-testid="nav-mobile-cta"
            >
              Book an Appointment
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
